import React, { type ReactElement } from "react";

import { Icon as ChakraIcon } from "@chakra-ui/react";

export interface IconProps {
  icon: ReactElement;
  size?: number;
  fillColor?: string;
  testId?: string;
}

const Icon = ({
  icon,
  size = 24,
  fillColor = "text",
  testId = "icon"
}: IconProps) => {
  const iconSize = {
    w: `${size}px`,
    h: `${size}px`
  };

  const newIcon = React.cloneElement(
    icon,
    fillColor === "default"
      ? { ...iconSize }
      : { ...iconSize, color: fillColor }
  );

  return <ChakraIcon data-bark-component="Icon" data-testid={testId}>{newIcon}</ChakraIcon>;
};

export default Icon;
